export default __webpack_public_path__ + "static/media/go-mini.1a9b6e74.glb";